import { render, staticRenderFns } from "./PrintActions.vue?vue&type=template&id=24f71e5c&"
import script from "./PrintActions.vue?vue&type=script&lang=js&"
export * from "./PrintActions.vue?vue&type=script&lang=js&"
import style0 from "./PrintActions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VContainer,VDivider,VRow})
